import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "etiqueta-editor-page"
  }, [_vm.loading ? _c('div', {
    staticClass: "editor-loading"
  }, [_c('div', {
    staticClass: "spinner spinner-primary spinner-lg"
  }), _c('strong', [_vm._v("Preparando o editor visual...")]), _c('span', [_vm._v("O modelo em uso não será alterado.")])]) : _vm.model && _vm.definition ? [_c('header', {
    staticClass: "editor-header"
  }, [_c('div', {
    staticClass: "editor-identity"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-light mr-3",
    attrs: {
      "type": "button",
      "title": "Voltar aos modelos"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._m(0), _c('div', {
    staticClass: "editor-title-wrap"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap mb-1"
  }, [_c('span', {
    class: ['editor-state', _vm.publicationStateClass]
  }, [_c('i'), _vm._v(_vm._s(_vm.publicationStateLabel))]), _c('span', {
    staticClass: "editor-origin"
  }, [_vm._v(_vm._s(_vm.model.origem === "legado" ? "Origem: ".concat(_vm.model.codigo_legado) : "Criada no editor"))]), _c('span', {
    staticClass: "editor-origin"
  }, [_c('i', {
    staticClass: "fas fa-building mr-1"
  }), _vm._v(_vm._s(_vm.scopeLabel(_vm.model)))])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.name,
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "editor-name",
    attrs: {
      "maxlength": "120",
      "aria-label": "Nome do modelo"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.name = $event.target.value.trim();
      }, _vm.markMetadataChanged],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "editor-actions"
  }, [_c('div', {
    staticClass: "history-actions"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-light",
    attrs: {
      "type": "button",
      "title": "Desfazer",
      "disabled": !_vm.undoStack.length
    },
    on: {
      "click": _vm.undo
    }
  }, [_c('i', {
    staticClass: "fas fa-undo"
  })]), _c('button', {
    staticClass: "btn btn-icon btn-light",
    attrs: {
      "type": "button",
      "title": "Refazer",
      "disabled": !_vm.redoStack.length
    },
    on: {
      "click": _vm.redo
    }
  }, [_c('i', {
    staticClass: "fas fa-redo"
  })]), _c('button', {
    staticClass: "btn btn-icon btn-light",
    attrs: {
      "type": "button",
      "title": "Histórico de versões"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('etiqueta-history-modal');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-history"
  })])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    class: {
      'spinner spinner-primary spinner-right': _vm.testing
    },
    attrs: {
      "type": "button",
      "disabled": _vm.testing || _vm.saving || _vm.publishing || _vm.discarding
    },
    on: {
      "click": _vm.testPrint
    }
  }, [_c('i', {
    staticClass: "fas fa-print mr-2"
  }), _vm._v("Impressão teste "), _vm.labelQuantity > 1 ? _c('span', [_vm._v("(" + _vm._s(_vm.labelQuantity) + ")")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    class: {
      'spinner spinner-dark spinner-right': _vm.saving
    },
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.publishing || _vm.discarding
    },
    on: {
      "click": function click($event) {
        return _vm.saveDraft();
      }
    }
  }, [_c('i', {
    staticClass: "far fa-save mr-2"
  }), _vm._v("Salvar rascunho ")]), _vm.model.tem_rascunho ? _c('button', {
    staticClass: "btn btn-light-danger font-weight-bold",
    class: {
      'spinner spinner-danger spinner-right': _vm.discarding
    },
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.publishing || _vm.testing || _vm.discarding
    },
    on: {
      "click": _vm.discardDraft
    }
  }, [_c('i', {
    staticClass: "fas fa-undo-alt mr-2"
  }), _vm._v(_vm._s(_vm.discardDraftLabel) + " ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-success font-weight-bold",
    class: {
      'spinner spinner-light spinner-right': _vm.publishing
    },
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.publishing || _vm.testing || _vm.discarding || !_vm.dirty && !_vm.model.tem_rascunho || !_vm.hasCurrentPrintApproval,
      "title": _vm.publishButtonTitle
    },
    on: {
      "click": _vm.publish
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle mr-2"
  }), _vm._v("Publicar ")])])]), _c('div', {
    staticClass: "editor-layout"
  }, [_c('aside', {
    staticClass: "editor-sidebar card card-custom"
  }, [_c('b-tabs', {
    attrs: {
      "pills": "",
      "nav-class": "sidebar-tabs",
      "content-class": "sidebar-content",
      "fill": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-plus-circle"
        }), _c('span', [_vm._v("Conteúdo")])];
      },
      proxy: true
    }])
  }, [_c('field-palette', {
    attrs: {
      "fields": _vm.bootstrap.campos || [],
      "print-options": _vm.effectiveTestOptions,
      "custom-text": _vm.customPrintText,
      "elements": _vm.definition.elementos || [],
      "selected-id": _vm.selectedId,
      "converted-legacy": Boolean(_vm.definition.importacao_legado)
    },
    on: {
      "add": _vm.addElement,
      "select": function select($event) {
        _vm.selectedId = $event;
      }
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-ruler-combined"
        }), _c('span', [_vm._v("Formato")])];
      },
      proxy: true
    }])
  }, [_c('format-settings', {
    attrs: {
      "definition": _vm.definition
    },
    on: {
      "change-start": _vm.recordHistory,
      "update": _vm.replaceDefinition
    }
  })], 1), _c('b-tab', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fas fa-flask"
        }), _c('span', [_vm._v("Exemplo")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "sample-panel"
  }, [_c('div', {
    staticClass: "sample-heading"
  }, [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Conferência e ajustes rápidos")]), _c('h5', [_vm._v("Teste e tamanho dos textos")]), _c('p', [_vm._v(" Troque os valores para conferir textos curtos, longos e preços sem alterar produtos. O tamanho de fonte abaixo altera a etiqueta de verdade. ")])]), _c('quick-font-settings', {
    attrs: {
      "elements": _vm.definition.elementos || [],
      "print-options": _vm.effectiveTestOptions
    },
    on: {
      "change": _vm.setElementFontSize
    }
  }), _c('div', {
    staticClass: "sample-company"
  }, [_c('div', {
    staticClass: "sample-company-label"
  }, [_c('span', [_vm._v("Empresa usada no teste")]), _c('small', [_vm._v("Define logo, razão social e dados exibidos na etiqueta.")])]), _vm.exampleCompany ? _c('div', {
    staticClass: "selected-test-company"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-building"
  })]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.companyName(_vm.exampleCompany)))]), _vm.model.escopo === 'empresa' ? _c('small', [_vm._v("Empresa fixa deste modelo")]) : _c('small', [_vm._v("Usada somente nesta prévia e teste")])]), _vm.model.escopo === 'global' ? _c('button', {
    staticClass: "btn btn-xs btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeExampleCompany
    }
  }, [_vm._v(" Trocar ")]) : _vm._e()]) : _vm.model.escopo === 'global' ? [_c('div', {
    staticClass: "input-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.exampleCompanySearch,
      expression: "exampleCompanySearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "Busque a empresa por nome ou CNPJ"
    },
    domProps: {
      "value": _vm.exampleCompanySearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.exampleCompanySearch = $event.target.value.trim();
      }, _vm.scheduleExampleCompanySearch],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_c('i', {
    class: _vm.searchingExampleCompanies ? 'spinner spinner-sm spinner-primary' : 'flaticon2-search-1 text-muted'
  })])]), _vm.exampleCompanyResults.length ? _c('div', {
    staticClass: "test-company-results"
  }, _vm._l(_vm.exampleCompanyResults, function (company) {
    return _c('button', {
      key: company.id_empresa,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectExampleCompany(company);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.companyName(company)))]), _c('i', {
      staticClass: "fas fa-chevron-right"
    })]);
  }), 0) : _vm.exampleCompanySearch && !_vm.searchingExampleCompanies ? _c('small', {
    staticClass: "text-danger d-block mt-2"
  }, [_vm._v("Nenhuma empresa encontrada.")]) : _vm._e()] : _vm._e()], 2), _vm.exampleCompanyId ? _c('product-example-picker', {
    attrs: {
      "model-uuid": _vm.model.uuid,
      "company-id": _vm.exampleCompanyId,
      "selected-product": _vm.selectedExampleProduct,
      "options": _vm.effectiveTestOptions
    },
    on: {
      "select": _vm.selectExampleProduct,
      "clear": _vm.clearExampleProduct
    }
  }) : _vm._e(), _c('legacy-print-options', {
    attrs: {
      "value": _vm.testOptions,
      "custom-text": _vm.customPrintText
    },
    on: {
      "change": _vm.setLegacyPrintOption,
      "update:custom-text": _vm.setCustomPrintText
    }
  }), _c('div', {
    staticClass: "sample-fields"
  }, _vm._l(_vm.importantSampleFields, function (field) {
    return _c('div', {
      key: field.key,
      staticClass: "form-group"
    }, [_c('label', [_vm._v(_vm._s(field.label))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.sampleValues[field.key],
        expression: "sampleValues[field.key]"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "placeholder": field.sample
      },
      domProps: {
        "value": _vm.sampleValues[field.key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.sampleValues, field.key, $event.target.value);
        }
      }
    })]);
  }), 0), _c('button', {
    staticClass: "btn btn-sm btn-light-primary btn-block font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSampleValues
    }
  }, [_vm._v(" Restaurar dados de exemplo ")])], 1)])], 1)], 1), _c('main', {
    staticClass: "editor-canvas-column"
  }, [_c('div', {
    staticClass: "canvas-controls card card-custom"
  }, [_c('div', {
    staticClass: "canvas-control-group"
  }, [_c('span', [_vm._v("Zoom")]), _c('button', {
    staticClass: "btn btn-xs btn-icon btn-light",
    attrs: {
      "type": "button",
      "disabled": _vm.zoom <= 50
    },
    on: {
      "click": function click($event) {
        _vm.zoom = Math.max(50, _vm.zoom - 10);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.zoom,
      expression: "zoom",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "min": "50",
      "max": "200",
      "step": "10",
      "aria-label": "Zoom da etiqueta"
    },
    domProps: {
      "value": _vm.zoom
    },
    on: {
      "__r": function __r($event) {
        _vm.zoom = _vm._n($event.target.value);
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('button', {
    staticClass: "btn btn-xs btn-icon btn-light",
    attrs: {
      "type": "button",
      "disabled": _vm.zoom >= 200
    },
    on: {
      "click": function click($event) {
        _vm.zoom = Math.min(200, _vm.zoom + 10);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _c('strong', [_vm._v(_vm._s(_vm.zoom) + "%")])]), _c('label', {
    staticClass: "grid-toggle"
  }, [_vm._m(1), _c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.showGrid,
      callback: function callback($$v) {
        _vm.showGrid = $$v;
      },
      expression: "showGrid"
    }
  })], 1)]), _c('label-canvas', {
    attrs: {
      "definition": _vm.definition,
      "sample-values": _vm.sampleValues,
      "test-options": _vm.effectiveTestOptions,
      "example-company-id": _vm.exampleCompanyId,
      "selected-id": _vm.selectedId,
      "zoom": _vm.zoom,
      "show-grid": _vm.showGrid
    },
    on: {
      "select": function select($event) {
        _vm.selectedId = $event;
      },
      "change-start": _vm.recordHistory,
      "update": _vm.updateElement
    }
  }), _c('print-engine-preview', {
    attrs: {
      "pdf-url": _vm.enginePreviewPdfUrl,
      "loading": _vm.enginePreviewLoading,
      "error": _vm.enginePreviewError,
      "outdated": _vm.enginePreviewOutdated,
      "quantity": _vm.labelQuantity,
      "max-quantity": 500,
      "warnings": _vm.warnings,
      "revision": _vm.enginePreviewRevision
    },
    on: {
      "update:quantity": _vm.setLabelQuantity,
      "generate": _vm.requestEnginePreviewNow
    }
  }), _vm.model.origem === 'legado' ? _c('div', {
    staticClass: "conversion-note"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _c('div', [_vm.needsLegacyReimport ? _c('span', [_c('strong', [_vm._v("Conversão criada pelo importador antigo:")]), _vm._v(" este rascunho pode ser recriado com a conversão atualizada. O legado continua em uso até uma publicação explícita. ")]) : _c('span', [_c('strong', [_vm._v("Conversão inicial aproximada:")]), _vm._v(" confira medidas e faça uma impressão teste. O legado segue ativo enquanto esta versão não for publicada. ")]), _vm.needsLegacyReimport ? _c('button', {
    staticClass: "btn btn-xs btn-outline-warning font-weight-bold mt-2",
    attrs: {
      "type": "button",
      "disabled": _vm.discarding
    },
    on: {
      "click": _vm.reimportLegacyDraft
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt mr-1"
  }), _vm._v("Refazer conversão do legado ")]) : _vm._e()])]) : _vm._e()], 1), _c('aside', {
    staticClass: "editor-right-column"
  }, [_c('div', {
    staticClass: "card card-custom inspector-card"
  }, [_c('element-inspector', {
    attrs: {
      "element": _vm.selectedElement,
      "label": _vm.definition.etiqueta,
      "fields": _vm.bootstrap.campos || [],
      "fonts": _vm.bootstrap.fontes || [],
      "barcode-types": _vm.bootstrap.tipos_codigo_barras || [],
      "display-rules": _vm.bootstrap.regras_exibicao || []
    },
    on: {
      "change-start": _vm.recordHistory,
      "update": _vm.updateElement,
      "duplicate": _vm.duplicateSelected,
      "delete": _vm.deleteSelected,
      "center-horizontal": _vm.centerSelectedHorizontally,
      "center-vertical": _vm.centerSelectedVertically,
      "front": _vm.bringSelectedToFront
    }
  })], 1), _c('div', {
    staticClass: "card card-custom sheet-card"
  }, [_c('sheet-preview', {
    attrs: {
      "definition": _vm.definition,
      "warnings": _vm.warnings,
      "compact": ""
    }
  })], 1)])]), _c('b-modal', {
    attrs: {
      "id": "etiqueta-history-modal",
      "title": "Histórico e recuperação",
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('version-history', {
    attrs: {
      "history": _vm.model.historico || [],
      "published-id": _vm.model.publicada ? _vm.model.publicada.id : null,
      "origin": _vm.model.origem,
      "has-publication": _vm.model.tem_publicacao
    },
    on: {
      "restore": _vm.restoreVersion,
      "reactivate-legacy": _vm.reactivateLegacy
    }
  })], 1)] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "editor-symbol"
  }, [_c('i', {
    staticClass: "fas fa-tags"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('i', {
    staticClass: "fas fa-border-all"
  }), _vm._v("Grade")]);
}];
export { render, staticRenderFns };